import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class LateEarlyDetailsDto implements ILateEarlyDetailsDto {
    entryDate!: Date;
    status!: string | undefined;
    timings!: string | undefined;
    lateTime!: string | undefined;
    earlyTime!: string | undefined;
    employee!: EmployeeSummaryDto;
    thumbInTime!: Date | undefined;
    thumbOutTime!: Date | undefined;
    empLegalName!: string | undefined;

    constructor(data?: ILateEarlyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.timings = _data["timings"];
            this.lateTime = _data["lateTime"];
            this.earlyTime = _data["earlyTime"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.thumbInTime = _data["thumbInTime"] ? new Date(_data["thumbInTime"].toString()) : <any>undefined;
            this.thumbOutTime = _data["thumbOutTime"] ? new Date(_data["thumbOutTime"].toString()) : <any>undefined;
            this.empLegalName = _data["empLegalName"];
        }
    }

    static fromJS(data: any): LateEarlyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LateEarlyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["timings"] = this.timings;
        data["lateTime"] = this.lateTime;
        data["earlyTime"] = this.earlyTime;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["thumbInTime"] = this.thumbInTime ? this.thumbInTime.toISOString() : <any>undefined;
        data["thumbOutTime"] = this.thumbOutTime ? this.thumbOutTime.toISOString() : <any>undefined;
        data["empLegalName"] = this.empLegalName;
        return data; 
    }
}

export interface ILateEarlyDetailsDto {
    entryDate: Date;
    status: string | undefined;
    timings: string | undefined;
    lateTime: string | undefined;
    earlyTime: string | undefined;
    employee: EmployeeSummaryDto;
    thumbInTime: Date | undefined;
    thumbOutTime: Date | undefined;
    empLegalName: string | undefined;
}

